var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightCircle = function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm.624 4.375-.067-.058a.6.6 0 0 0-.706-.006l-.075.064-.058.067a.6.6 0 0 0-.006.707l.064.075 2.175 2.175H6.6l-.081.006a.6.6 0 0 0-.513.513l-.006.081.006.082a.6.6 0 0 0 .513.513l.081.005h5.352l-2.176 2.177-.058.067a.6.6 0 0 0 .84.84l.067-.059 3.2-3.2.059-.067a.6.6 0 0 0 .006-.706l-.064-.075-3.2-3.2-.068-.059.067.058Z",
    fill: "#666"
  })));
};
export default SvgArrowRightCircle;